export default {"src":"/_next/static/media/cry.b587b830.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};